import { toEnum } from '@tryiris-ai/js-types';
import type { T_Maybe } from '@tryiris-ai/js-types';
import { PrefKeys } from './constants.js';
import { GridLines, Tool } from './types.js';
import { preferences } from '#~/preferences/index.js';

/**
 * Imperatively set the selected tool.
 *
 * @param tool - The tool to be selected.
 */
export const setTool = (tool: Tool): void => {
  const state = preferences.getState();

  state.produce((draft) => {
    draft.setValue(PrefKeys.tool, tool);
  });
};

/**
 * Transforms the specified value to a `GridLines` enumeration.
 *
 * @param value - The value to be transformed.
 * @returns The transformed `GridLines` enumeration or `undefined`.
 */
export const toGridLines = (value: unknown): T_Maybe<GridLines> =>
  toEnum(GridLines, value, {
    aliases: {
      [GridLines.Thirds]: ['third', '1/3'],
      [GridLines.Center]: ['c', '1/2']
    }
  });

/**
 * Transforms the specified value to a `Tool` enumeration.
 *
 * @param value - The value to be transformed.
 * @returns The transformed `Tool` enumeration or `undefined`.
 */
export const toTool = (value: unknown): T_Maybe<Tool> =>
  toEnum(Tool, value, {
    aliases: {
      [Tool.Tracking]: ['auto', 'auto-tracking', 'a', 't'],
      [Tool.FastFrame]: ['fast', 'frame', 'ff', 'f'],
      [Tool.Center]: ['c'],
      [Tool.Joystick]: ['j']
    }
  });
